type UserFullName = {
  first_name?: string | null
  last_name?: string | null
}

type UserAddress = {
  district?: string | null
  location?: string | null
  street?: string | null
  number?: string | null
  block?: string | null
  apartment?: string | null
}

export const getFullName = (user?: UserFullName | null) => {
  if (!user) {
    return ''
  }

  const { first_name, last_name } = user

  return [last_name, first_name]?.filter(Boolean)?.join(' ')
}

export const getInitials = (fullName: string) =>
  fullName
    .split(' ')
    .map((name) => name[0])
    .join('')

export const getUserInitials = ({ last_name, first_name }: UserFullName) =>
  getInitials(getFullName({ last_name, first_name }))

export const getUserAddress = (address?: UserAddress) => {
  if (!address) return ''

  const { district, location, street, number, block, apartment } = address

  return [district, location, street, number, block, apartment]
    .filter(Boolean)
    .join(', ')
}
